import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ExchangeItemForm from "./exchangeItemForm";
export default {
  name: "searchItemForm",
  components: {
    ExchangeItemForm: ExchangeItemForm
  },
  props: ["itemIndex", "myKey", "itemData"],
  data: function data() {
    return {
      show: false,
      baseUrl: process.env.BASE_URL,
      formData: {
        exchange: [],
        type: "",
        queryField: "",
        showName: "",
        queryType: "",
        key: ""
      },
      stringifyExchange: "",
      ruleValidate: {
        queryField: [{
          required: true,
          message: "参数名不能为空",
          trigger: "blur"
        }],
        exchange: [{
          required: true,
          message: "请设定值",
          trigger: "blur"
        }],
        showName: [{
          required: true,
          message: "显示名称不能为空",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择类型",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {
    // this.setKey()
    this.setDefualtData();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    setExchange: function setExchange() {
      this.show = true;

      if (this.formData.exchange.length == 0) {
        this.formData.exchange.push({
          name: "",
          value: "",
          key: new Date().getTime() // 加入唯一标识避免渲染错误

        });
      }

      var _this = this;

      this.$nextTick(function () {
        _this.formData.exchange.forEach(function (item, index) {
          _this.$refs.dictionary[index].getDefualtData();
        });
      });
    },
    addExchange: function addExchange() {
      var exchange = this.formData.exchange;
      this.formData.exchange.push({
        name: "",
        value: "",
        key: new Date().getTime() // 加入唯一标识避免渲染错误

      });

      var _this = this;

      this.$nextTick(function () {
        _this.$refs.dictionary[_this.formData.exchange.length - 1].getDefualtData();
      });
    },
    handleClose: function handleClose() {
      // 过滤掉未保存的数据
      this.formData.exchange = this.formData.exchange.filter(function (item) {
        return item.name && item.value;
      });
      this.show = false;
    },
    validateDictionaryForm: function validateDictionaryForm() {
      var _this2 = this;

      var resultArr = [];

      var _this = this;

      function checkForm(index) {
        var result = new Promise(function (resolve, reject) {
          _this.$refs.dictionary[index].$refs.dictionaryForm.validate(function (valid) {
            if (valid) {
              resolve(_this.$refs.dictionary[index].getData());
            } else {
              reject();
            }
          });
        });
        resultArr.push(result);
      }

      this.formData.exchange.forEach(function (item, index) {
        checkForm(index);
      });
      Promise.all(resultArr).then(function (res) {
        _this2.formData.exchange = res;
        _this2.stringifyExchange = JSON.stringify(res);
        _this2.show = false;
      });
    },
    removeItem: function removeItem(index) {
      this.formData.exchange.splice(index, 1);
    },
    getValue: function getValue() {
      return this.formData;
    },
    removeSearchItem: function removeSearchItem() {
      this.$emit("removeItemForm", {
        dataName: "queryCondDefList",
        index: this.itemIndex
      });
    },
    setDefualtData: function setDefualtData() {
      this.formData = {
        key: this.itemData.key,
        type: this.itemData.type,
        queryField: this.itemData.queryField,
        showName: this.itemData.showName,
        queryType: this.itemData.queryType,
        exchange: []
      };

      if (this.itemData.exchange && this.itemData.exchange.length) {
        this.formData.exchange = JSON.parse(this.itemData.exchange);
        this.stringifyExchange = this.itemData.exchange;
      }
    },
    typeChange: function typeChange() {
      this.formData.queryType = "0";
    }
  },
  watch: {
    formData: {
      handler: function handler(val) {
        var data = JSON.parse(JSON.stringify(val));
        data.exchange = this.stringifyExchange;
        this.$emit("searchItemFormChange", {
          data: data,
          index: this.itemIndex
        });
      },
      deep: true
    }
  },
  filters: {}
};